(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('onu', {
                    parent: 'app.private',
                    url: '/onu',
                    data: {
                        pageTitle: 'onu.title'
                    },
                    params: {
                        name: {value: null},
                        ip: {value: null},
                        port: {value: null}
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/onu/onu.html',
                            controller: 'OnuController',
                            controllerAs: 'vmOnu'
                        },
                        'search@onu': {
                            templateUrl: 'app/components/onu/onu-search.html',
                            controller: 'OnuSearchController',
                            controllerAs: 'vmOnuSearch'
                        },
                        'favorites@onu': {
                            templateUrl: 'app/components/favorites/favorites.html',
                            controller: 'FavoritesController',
                            controllerAs: 'vmFavorites'
                        },
                        'unauthorized@onu': {
                            templateUrl: 'app/components/onu/onu-list-unauthorized.html',
                            controller: 'OnuUnauthorizedController',
                            controllerAs: 'vmOnuUnauthorized'
                        },
                        'authorized@onu': {
                            templateUrl: 'app/components/onu/onu-list-authorized.html',
                            controller: 'OnuListAuthorizedController',
                            controllerAs: 'vmListAuthorized'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('onu');
                                $translatePartialLoader.addPart('onu-modals');
                                $translatePartialLoader.addPart('tooltip');
                                $translatePartialLoader.addPart('bridge');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();
